import React from 'react'
import { DefaultLayout } from '../../layouts'
import { SimplePageHeader, Container } from '../../components'
import {
  MainSection,
  ContentSection,
  RelatedEvents,
  // GallerySection,
  // TestimoniSection,
  // CommentSection,
} from './components'
import { normalizer } from '../../utils'
import rawData from '../../database/events.json'

const normalized = normalizer(rawData)

const EventDetail = (props) => {
  const { match } = props
  const data = normalized[match.params.id]

  return (
    <DefaultLayout>
      <SimplePageHeader noPadding/>
      <MainSection data={data} />
      <ContentSection data={data} />
      <Container>
        <hr className="my-10 lg:my-20" />
      </Container>
      {/* <Container>
        <div className="w-full lg:w-8/12">
          <GallerySection />
        </div>
      </Container>
      <Container>
        <hr className="my-10 lg:my-20" />
      </Container>
      <TestimoniSection />
      <Container>
        <hr className="my-10 lg:my-20" />
      </Container>
      <Container>
        <CommentSection />
      </Container>
      <Container>
        <hr className="my-10 lg:my-20" />
      </Container> */}
      <RelatedEvents />
    </DefaultLayout>
  )
}

export { EventDetail }